import { render, staticRenderFns } from "./CreditClassDetail.vue?vue&type=template&id=0cb8c898"
import script from "./CreditClassDetail.vue?vue&type=script&lang=js"
export * from "./CreditClassDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports